export const STATUS_REPORT = {
  0: {
    label: 'Pendente',
    style: 'warning-light'
  },
  1: {
    label: 'Finalizado',
    style: 'success-dark'
  },
  2: {
    label: 'Cancelado',
    style: 'warning-light'
  },
  3: {
    label: 'Erro',
    style: 'error-dark'
  }
}
